import { render, staticRenderFns } from "./RegionalCompletion.vue?vue&type=template&id=383a16ba&scoped=true"
import script from "./RegionalCompletion.vue?vue&type=script&lang=js"
export * from "./RegionalCompletion.vue?vue&type=script&lang=js"
import style0 from "./RegionalCompletion.vue?vue&type=style&index=0&id=383a16ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383a16ba",
  null
  
)

export default component.exports